var $625df06cecc70764$exports = {};
$625df06cecc70764$exports = {
  "breadcrumbs": "\u041D\u0430\u0432\u0438\u0433\u0430\u0446\u0438\u044F"
};
export { $625df06cecc70764$exports as default };